import { createRouter, createWebHistory } from 'vue-router'
import Index from '@/views/Index.vue'
import Wizard from '@/components/Wizard'
import ProgramsList from '@/components/Programs/List.vue'
import SelectedProgram from '@/components/Programs/Selected.vue'
import Imprint from '@/components/Imprint.vue'

const routerHistory = createWebHistory()
const router = createRouter({
  history: routerHistory,
  routes: [
    {
      path: '/site/:site?',
      props: true,
      component: Index,
      children: [
        {
          path: '',
          component: Wizard,
          meta: {
            depth: 0
          }
        },
        {
          path: 'result',
          name: 'result',
          component: ProgramsList,
          meta: {
            depth: 1
          }
        },
        {
          path: 'show/:slug?',
          name: 'selected',
          props: true,
          component: SelectedProgram,
          meta: {
            depth: 2
          }
        },
        {
          path: 'wizard',
          name: 'wizard',
          component: Wizard,
          meta: {
            depth: 0
          }
        },
        {
          path: 'impressum',
          name: 'imprint',
          component: Imprint,
          meta: {
            depth: 4
          }
        }
      ]
    }
  ]
})

export default router
